import { Cartesian3, JulianDate, ReferenceFrame, } from "cesium";
import { UNITS_DEF, } from "../../Entities";
import { getParsedValue } from "./converters";
import { meanMotionFromSMA, sv2orb } from "./propagation";
const day2Millis = 86400 * 1000;
const mjd2000Unix = 946684800 * 1000;
export function mjd2unix(mjd) {
    return mjd * day2Millis + mjd2000Unix;
}
export function unix2mjd(unix) {
    return (unix - mjd2000Unix) / day2Millis;
}
export function getJulianDateFromEpoch(epoch) {
    if (typeof epoch === "number")
        return JulianDate.fromDate(new Date(mjd2unix(epoch)));
    return JulianDate.fromIso8601(epoch, new JulianDate());
}
export const getSimulationTime = (startTime, stopTime) => {
    let julianStartTime = JulianDate.now();
    let julianStopTime = JulianDate.addDays(JulianDate.now(), 1, new JulianDate());
    if (startTime) {
        julianStartTime = getJulianDateFromEpoch(startTime);
    }
    if (stopTime) {
        julianStopTime = getJulianDateFromEpoch(stopTime);
    }
    if (JulianDate.compare(julianStopTime, julianStartTime) < 0) {
        julianStopTime = JulianDate.addDays(julianStartTime, 1, new JulianDate());
    }
    return { julianStartTime, julianStopTime };
};
export const getOrbitPeriodFromKeplerianElements = (keplerianElements) => {
    const { a, M } = keplerianElements;
    if (a)
        return (2 * Math.PI) / meanMotionFromSMA(a);
    if (M)
        return 86400 / M;
    return 3600;
};
export const getOrbitPeriodFromSampledPositionProperty = (samples) => {
    const times = samples._property._times;
    const firstEpoch = times[0];
    const secondEpoch = times[1];
    const diffTime = JulianDate.secondsDifference(secondEpoch, firstEpoch);
    const pos = samples.getValueInReferenceFrame(firstEpoch, ReferenceFrame.INERTIAL, new Cartesian3());
    const pos2 = samples.getValueInReferenceFrame(secondEpoch, ReferenceFrame.INERTIAL, new Cartesian3());
    const vel = Cartesian3.multiplyByScalar(Cartesian3.subtract(pos2, pos, new Cartesian3()), 1 / diffTime, new Cartesian3());
    const StateVectorWithEpoch = {
        epoch: JulianDate.toIso8601(firstEpoch),
        x: pos.x,
        y: pos.y,
        z: pos.z,
        xDot: vel.x,
        yDot: vel.y,
        zDot: vel.z,
    };
    return getOrbitPeriodFromObject(StateVectorWithEpoch);
};
export const getOrbitPeriodFromObject = (sv) => {
    const kep = sv2orb(getParsedValue(sv.x, UNITS_DEF.KM), getParsedValue(sv.y, UNITS_DEF.KM), getParsedValue(sv.z, UNITS_DEF.KM), getParsedValue(sv.xDot, UNITS_DEF.KM), getParsedValue(sv.yDot, UNITS_DEF.KM), getParsedValue(sv.zDot, UNITS_DEF.KM));
    const { a } = kep;
    const halfPeriod = Math.PI / meanMotionFromSMA(a);
    return 2.0 * halfPeriod;
};
//# sourceMappingURL=simulationTime.js.map